import { Component } from "react";
import {observer} from "mobx-react";
import PropTypes from 'prop-types';

import dynamic from 'next/dynamic';
import {StoreContext} from "../../stores/StoreLoader";

@observer
class AllModals extends Component {
    static contextType = StoreContext;

    static getComponent = {
        'news': dynamic(() => import('./SocialItemModal')),
        'cleverfeed-news': dynamic(() => import("./CleverFeedNews")),
        'admin': dynamic(() => import('./AdminModal/AdminModal')),
        'login': dynamic(() => import('./LoginModal')),
        'events': dynamic(() => import('./EventModal')),
        'review': dynamic(() => import("./ReviewModal")),
        'gallery': dynamic(() => import("./GalleryModal")),
        'addnews': dynamic(() => import('./Curation/AddNewsItemModal')),
        'addevent': dynamic(() => import('./Curation/AddEventItemModal')),
        'addmedia': dynamic(() => import('./Curation/AddGalleryItemModal')),
        'edit-description': dynamic(() => import('./Curation/DescriptionCurationModal')),
        'edit-location': dynamic(() => import('./Curation/LocationCurationModal')),
        'addquicklink': dynamic(() => import("./Curation/AddQuicklinkModal")),
        'sources-modal': dynamic(() => import("./SourcesModal")),
        'edit-hero': dynamic(() => import("./HeroEditor")),
        'organization': dynamic(() => import("./OrganizationModal")),
        'file-preview': dynamic(() => import("./FilePreviewModal")),
        'collectionManagement': dynamic(() => import("./CollectionManagementModal")),
        'peopleCollectionManagement': dynamic(() => import("./PeopleCollectionManagementModal")),
        'schoolBlocksEvent': dynamic(() => import("./SchoolBlocksEventModal")),
        'block': dynamic(() => import("./BlockModal")),
        "schoolDistrict": dynamic(() => import("./SchoolBlocksDistrictSchoolModal"), {ssr: false}),
        "sbOrganization": dynamic(() => import("./SchoolBlocksOrganizationModal/SchoolBlocksOrganizationModal"), {ssr: false}),
        "addOrEditBlock": dynamic(() => import("../blocks/SchoolBlocks/EditBlockComponents/ToolDrawerGrid/AddOrEditBlock")),
        "toolDrawerGrid": dynamic(() => import("../blocks/SchoolBlocks/EditBlockComponents/ToolDrawerGrid/ToolDrawerGrid")),
        "addOrEditAlert": dynamic(() => import("./AlertEditModal")),
        "helpModal": dynamic(() => import("./HelpModal"), {ssr: false}),
        "permissions": dynamic(() => import("./PermissionsModal/PermissionsModal")),
        "deleteDialog": dynamic(() => import("./DeleteOrganizationModal")),
        "confirm": dynamic(() => import("./ConfirmDialog")),
        "linkExternalClassroom": dynamic(() => import("./LinkExternalClassroomModal")),
        "calendarManagement": dynamic(() => import("./CalendarManagementModal/CalendarManagementModal")),
        "calendarList": dynamic(() => import("./CalendarManagementModal/CalendarListModal")),
        "comparePages": dynamic(() => import("./ComparePagesModal")),
        "revertPage": dynamic(() => import("./RevertDialog")),
        "fluxCapacitor": dynamic(() => import("./FluxCapacitorTimeline"), {ssr: false}),
        "googleFilePicker": dynamic(() => import("./GoogleFilePicker")),
        "schoolBlocksPerson": dynamic(() => import("./PersonModal/SchoolBlocksPersonModal")),
        "iconUpload": dynamic(() => import("./IconUpload")),
        "iosAppInstallHelp": dynamic(() => import("./iosAppInstallHelp")),
    };

    static propTypes = {
        modalObj: PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
            type: PropTypes.string.isRequired,
            theme: PropTypes.oneOf(['classic', 'transparent']),
        }),
    };

    render() {
        const {modalStore} = this.context;

        return (
            <div id="allModalContainer">
                {modalStore.stack.map((modalObj, index) => {
                    const ModalComponent = AllModals.getComponent[modalObj.type];
                    return (
                        <ModalComponent
                            key={index + modalObj.type}
                            id={modalObj.id}
                            type={modalObj.type}
                            theme={modalObj.theme ? modalObj.theme : 'classic'}
                            index={index}
                            modalObj={modalObj}
                        />
                    );
                })}
            </div>
        );
    }
}

export default AllModals
